export enum FEE_TYPE {
    None = 0,
    Service = 1,
    ExtraCharges = 2,
    TbiBankFee = 3,
    PayOnDeliveryFee = 4,
    Surcharge = 5
}
